import React from "react";
import { Modal, Row, Col, Card, Input } from "antd";
import { ArrowLeftOutlined, SearchOutlined } from "@ant-design/icons";
import { Scrollbars } from "react-custom-scrollbars";
import data from "../../../../constants/retailPos.json";

/**
 * Modal for viewing and selecting parked bills/orders.
 *
 * @param {Object} props
 * @param {Array} props.filteredList - Filtered parked bill list
 * @param {Function} props.onClose - Called when modal is closed
 * @param {Function} props.onSearch - Called on search submit
 * @param {Function} props.onSearchChange - Called when search input changes
 * @param {string} props.searchValue - Current search input value
 * @param {Function} props.onSelect - Called when a parked bill is selected
 */
const ParkedBillsModal = ({ filteredList, onClose, onSearch, onSearchChange, searchValue, onSelect }) => {
  return (
    <Modal closable={false} footer={null} styles={{ body: { padding: "20px 15px 15px" } }}>
      <div>
        <Row>
          <Col span={9}>
            <ArrowLeftOutlined style={data.posScreenStyles.orderHistoryModal.backArrowIcon} onClick={onClose} />
          </Col>
          <Col span={15}>
            <p style={data.posScreenStyles.parkedBillModal.parkedBillsHistoryModalTitle}>Parked Orders</p>
          </Col>
        </Row>
        <Row style={{ paddingBottom: "12px" }}>
          <Col span={24}>
            <Input
              placeholder="Customer Search Key"
              size="large"
              allowClear={false}
              style={data.posScreenStyles.orderHistoryModal.orderHistorySearchInput}
              onPressEnter={onSearch}
              onChange={onSearchChange}
              value={searchValue}
              suffix={<SearchOutlined onClick={onSearch} style={data.posScreenStyles.customerModal.searchIcon} />}
            />
          </Col>
        </Row>
        <Row>
          <Card className="orderHistoryCard" style={data.posScreenStyles.cardDetails} styles={{ body: { padding: 10 } }}>
            <Scrollbars className="orderHistoryScroll">
              {filteredList?.map((item, index) => (
                <Card
                  tabIndex={0}
                  onKeyDown={(e) => (e.keyCode === 13 ? onSelect(item) : null)}
                  key={`${index + 1}`}
                  style={data.posScreenStyles.orderHistoryModal.oderHistoryDetailsCard}
                  styles={{ body: { padding: 10 } }}
                  onClick={() => onSelect(item, "management")}
                >
                  <Row>
                    <Col span={12}>
                      <p style={data.posScreenStyles.orderHistoryModal.orderDate}>{item.parkedTime}</p>
                    </Col>
                    <Col span={12}>
                      <p style={data.posScreenStyles.orderHistoryModal.orderCustomerName}>{index + 1}</p>
                    </Col>
                  </Row>
                  <Row>
                    <Col span={12}>
                      <p style={data.posScreenStyles.orderHistoryModal.orderNum}>{item?.parkedCart?.customer?.name || ""}</p>
                    </Col>
                    <Col span={12}>
                      <p style={data.posScreenStyles.orderHistoryModal.orderStatus}>Parked</p>
                    </Col>
                  </Row>
                </Card>
              ))}
            </Scrollbars>
          </Card>
        </Row>
      </div>
    </Modal>
  );
};

export default ParkedBillsModal;
